import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { RingLoader } from "react-spinners";
import Backicon from "../../../shared/components/Backicon/Backicon";
import Tile from "../../../shared/components/Tile/Tile";
import styles from "./patientprofile.module.css";
import baseStyles from "../../../shared/styles/basestyles.module.css";

function PatientProfile() {
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setPageLoading(false), 3000);
  }, []);

  return (
    <div className={styles.phome}>
      <div className={baseStyles.container}>
        {pageLoading ? (
          <div className={styles.spinnerContainer}>
            <RingLoader size={100} color={"white"} />
          </div>
        ) : (
          <div>
            <Backicon onClick={() => this.props.history.goBack()} />
            <h1 className={styles.title}>Patient Profile</h1>
            <div className={styles.first}>
              <Link to="/patient/patient-details">
                <Tile
                  name="Patient Details"
                  style={{
                    height: "200px",
                    width: "250px",
                    fontSize: "2.5rem",
                    backgroundColor: "rgba(255, 255, 255, 0.619)",
                  }}
                />
              </Link>
              <Link to="/patient/doctors-nearby">
                <Tile
                  name="Doctor's Nearby"
                  style={{
                    height: "200px",
                    width: "250px",
                    fontSize: "2.5rem",
                    backgroundColor: "rgba(255, 255, 255, 0.619)",
                  }}
                />
              </Link>
              <Link to="/patient/appointments">
                <Tile
                  name="Appointment"
                  style={{
                    height: "200px",
                    width: "250px",
                    fontSize: "2.5rem",
                    backgroundColor: "rgba(255, 255, 255, 0.619)",
                  }}
                />
              </Link>
            </div>
            <div className={styles.second}>
              <Link to="/patient/health-reports">
                <Tile
                  name="Health Report "
                  style={{
                    height: "200px",
                    width: "250px",
                    fontSize: "2.5rem",
                    backgroundColor: "rgba(255, 255, 255, 0.619)",
                  }}
                />
              </Link>
              <Link to="/patient/expense-report">
                <Tile
                  name="Expense Report"
                  style={{
                    height: "200px",
                    width: "250px",
                    fontSize: "2.5rem",
                    backgroundColor: "rgba(255, 255, 255, 0.619)",
                  }}
                />
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
export default PatientProfile;
